export default __webpack_public_path__ + "static/media/Karnataka7.0177aee1.png";